import * as tslib_1 from "tslib";
import { Directive, ElementRef, Input, OnChanges, Renderer2, SimpleChanges, TemplateRef, ViewContainerRef } from '@angular/core';
import { mediaApi } from '@sitecore-jss/sitecore-jss';
import * as ɵngcc0 from '@angular/core';
let ImageDirective = class ImageDirective {
    constructor(viewContainer, templateRef, renderer, elementRef) {
        this.viewContainer = viewContainer;
        this.templateRef = templateRef;
        this.renderer = renderer;
        this.elementRef = elementRef;
        this.inlineRef = null;
        // tslint:disable-next-line:no-input-rename
        this.editable = true;
        // tslint:disable-next-line:no-input-rename
        this.urlParams = {};
        // tslint:disable-next-line:no-input-rename
        this.attrs = {};
    }
    ngOnChanges(changes) {
        if (changes['field'] || changes['editable'] || changes['urlParams'] || changes['attrs']) {
            this.viewContainer.clear();
            if (this.inlineRef) {
                this.inlineRef.remove();
                this.inlineRef = null;
            }
            this.updateView();
        }
    }
    updateView() {
        const overrideAttrs = Object.assign({}, this.getElementAttrs(), this.attrs);
        const media = this.field;
        if (!media || (!media.editable && !media.value && !media.src)) {
            return;
        }
        let attrs = {};
        // we likely have an experience editor value, should be a string
        if (this.editable && media.editable) {
            const foundImg = mediaApi.findEditorImageTag(media.editable);
            if (!foundImg) {
                return this.renderInlineWrapper(media.editable);
            }
            attrs = this.getImageAttrs(foundImg.attrs, overrideAttrs, this.urlParams);
            if (!attrs) {
                return this.renderInlineWrapper(media.editable);
            }
            const tempImg = this.renderer.createElement('img');
            Object.entries(attrs).forEach(([key, attrValue]) => tempImg.setAttribute(key, attrValue));
            const editableMarkup = media.editable.replace(foundImg.imgTag, tempImg.outerHTML);
            return this.renderInlineWrapper(editableMarkup);
        }
        // some wise-guy/gal is passing in a 'raw' image object value
        const img = media.src ? media : media.value;
        if (!img) {
            return null;
        }
        attrs = this.getImageAttrs(img, overrideAttrs, this.urlParams);
        if (attrs) {
            this.renderTemplate(attrs);
        }
    }
    getImageAttrs(fieldAttrs, parsedAttrs, imageParams) {
        const combinedAttrs = Object.assign({}, fieldAttrs, parsedAttrs);
        // tslint:disable-next-line:prefer-const
        let { src, srcSet } = combinedAttrs, otherAttrs = tslib_1.__rest(combinedAttrs, ["src", "srcSet"]);
        if (!src) {
            return null;
        }
        const newAttrs = Object.assign({}, otherAttrs);
        // update image URL for jss handler and image rendering params
        src = mediaApi.updateImageUrl(src, imageParams);
        if (srcSet) {
            // replace with HTML-formatted srcset, including updated image URLs
            newAttrs.srcSet = mediaApi.getSrcSet(src, srcSet, imageParams);
        }
        else {
            newAttrs.src = src;
        }
        return newAttrs;
    }
    renderTemplate(imageProps) {
        const viewRef = this.viewContainer.createEmbeddedView(this.templateRef);
        viewRef.rootNodes.forEach((node) => {
            Object.entries(imageProps).forEach(([key, imgPropVal]) => this.renderer.setAttribute(node, key, imgPropVal));
        });
    }
    getElementAttrs() {
        const view = this.templateRef.createEmbeddedView(null);
        const element = view.rootNodes[0];
        if (!element) {
            return {};
        }
        const attrs = {};
        for (let i = 0; i < element.attributes.length; i++) {
            const attr = element.attributes.item(i);
            if (attr) {
                attrs[attr.name] = attr.value;
            }
        }
        return attrs;
    }
    renderInlineWrapper(editable) {
        const span = this.renderer.createElement('span');
        span.className = 'sc-image-wrapper';
        span.innerHTML = editable;
        const parentNode = this.renderer.parentNode(this.elementRef.nativeElement);
        this.renderer.insertBefore(parentNode, span, this.elementRef.nativeElement);
        parentNode.removeChild(this.elementRef.nativeElement);
        this.inlineRef = span;
    }
};
ImageDirective.ɵfac = function ImageDirective_Factory(t) { return new (t || ImageDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
ImageDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: ImageDirective, selectors: [["", "scImage", ""]], inputs: { editable: ["scImageEditable", "editable"], urlParams: ["scImageUrlParams", "urlParams"], attrs: ["scImageAttrs", "attrs"], field: ["scImage", "field"] }, features: [ɵngcc0.ɵɵNgOnChangesFeature] });
ImageDirective.ctorParameters = () => [
    { type: ViewContainerRef },
    { type: TemplateRef },
    { type: Renderer2 },
    { type: ElementRef }
];
tslib_1.__decorate([
    Input('scImage')
], ImageDirective.prototype, "field", void 0);
tslib_1.__decorate([
    Input('scImageEditable')
], ImageDirective.prototype, "editable", void 0);
tslib_1.__decorate([
    Input('scImageUrlParams')
], ImageDirective.prototype, "urlParams", void 0);
tslib_1.__decorate([
    Input('scImageAttrs')
], ImageDirective.prototype, "attrs", void 0);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ImageDirective, [{
        type: Directive,
        args: [{ selector: '[scImage]' }]
    }], function () { return [{ type: ɵngcc0.ViewContainerRef }, { type: ɵngcc0.TemplateRef }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }]; }, { editable: [{
            type: Input,
            args: ['scImageEditable']
        }], urlParams: [{
            type: Input,
            args: ['scImageUrlParams']
        }], attrs: [{
            type: Input,
            args: ['scImageAttrs']
        }], field: [{
            type: Input,
            args: ['scImage']
        }] }); })();
export { ImageDirective };
